<template>
    <div class="tb-row p-6">
        <div :style="labelStyles">
            <slot name="title" v-if="title">{{title}}</slot>
            <slot name="title"></slot>
        </div>
        <div class="ti-g-1">
            <slot name="value" v-if="value">{{value}}</slot>
            <slot slot-scope></slot>
        </div>
    </div>
</template>
<script>
    export default {
        name: "Cell",
        data() {
            return {};
        },
        computed: {
            labelStyles() {
                return {
                    width: this.$parent.labelWidth || "160px",
                    textAlign: this.$parent.labelAlign || "right",
                    marginRight: this.$parent.labelMarginRight || "15px"
                };
            }
        },
        props: {
            title: [String, Number],
            value: [String, Number, Array]
        }
    };
</script>

